import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './app.js';
import './styles/global.css';
/* A folha do console vem DEPOIS da fundação: mesma cascata, ordem explícita. */
import './styles/console.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento #root não encontrado.');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Dado fiscal não é revalidado por acidente de foco de janela.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
